import React, { useState, useEffect } from "react";
import PT from "prop-types";
// import { useSelector } from "react-redux";
import get from "lodash/get";
import getStoriesByCollection from "../../../utils";
import AuthorWithTime from "../../molecules/author-with-time";
import { Link } from "@quintype/components";
import { CardImage } from "../../atoms/card-image";
import { CollectionName } from "../../atoms/collection-name";
import { Headline } from "../../atoms/headline";
import {
  SUBSCRIPTION_PAGE_URL
  // INDEPENDENCE_DAY_OFFER_PAGE_URL
} from "../../../../isomorphic/constants";
import EnglishBanner from "../../../../assets/images/nl-images/english-vertical-banner.png";
import HindiBanner from "../../../../assets/images/nl-images/hindi-vertical-banner.png";
// import ChristmasBanner from "../../../../assets/images/nl-images/ChristmasDeal.jpg";
import assetify from "@quintype/framework/assetify";
import "./four-stories-with-banner.m.css";

export const FourStoriesWithBanner = ({ collection }) => {
  var stories = getStoriesByCollection(collection);
  const [location, setLocation] = useState("");
  // const collections = collection.items.filter(
  //   collection => collection.type === "collection"
  // );
  if (stories.length < 1) {
    return null;
  }

  // const hasSubscription = useSelector(state => {
  //   return get(state, ["isSubscribedUser", "userHasSubscription"], null);
  // });

  useEffect(() => {
    setLocation(global.location.host);
  }, []);

  const getStoryCard = slice => {
    return (
      stories &&
      stories.slice(0, slice).map((story, index) => {
        const section = get(story, ["sections", "0"], {});
        const getLabel = get(
          story,
          ["metadata", "story-attributes", "storyattribute", 0],
          ""
        );
        return (
          <div key={index} styleName="story-wrapper">
            <CardImage story={story} />
            {getLabel && <div styleName="ribbon">{getLabel}</div>}
            <div styleName="text-wrapper">
              <Link href={section["section-url"]}>
                <div styleName="section">
                  {section["display-name"] || section.name}
                </div>
              </Link>
              <Headline story={story} externalLink={true} />
              <div styleName="author-details">
                <AuthorWithTime story={story} />
              </div>
            </div>
          </div>
        );
      })
    );
  };

  const hindiPage =
    location === "hindi.newslaundry.com" ||
    location === "newslaundry-hindi-web.qtstage.io" ||
    location === "hindi.lvh.me:3000";

  if (!hindiPage) {
    stories = stories.filter(item => item.url.slice(8, 13) !== "hindi");
  }
  return (
    <div className="full-width-with-padding" styleName="wrapper">
      <div styleName="container" className="container">
        {<CollectionName collection={collection} />}
        <div styleName="layout-grid">
          <>{getStoryCard(4)}</>

          <Link styleName="sena-wrapper"  href={`/subscription?ref=vertical-offer`}>
            {hindiPage ? (
              <img styleName="banner" src={assetify(HindiBanner)} />
            ) : (
              <img styleName="banner" src={assetify(EnglishBanner)} />
            )}
            <div styleName="sub-con">
              <div styleName="sub-btn">
                {hindiPage ? "सब्सक्राइब करें" : "Subscribe"}
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

FourStoriesWithBanner.propTypes = {
  collection: PT.object
};
